;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useState } from 'react';
import Link from 'next/link';
import { Button, ListGroup } from 'reactstrap';
import { MdOutlineChevronRight, MdOutlineInfo } from 'react-icons/md';

import useWindowWidth from '../../../hooks/useWindowWidth';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import JobTeaser from '../../JobTeaser';
import Loading from '../../Loading';
import JobmatchInfoModal from '../JobmatchInfoModal';
import JobmatchNoResults from '../JobmatchNoResults';
import { Dictionaries } from '../../../i18n/i18n-config';
import { useParams } from 'next/navigation';
import { getI18nUtils } from '../../../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
  isLoading: boolean;
  jobMatches: JobMatchResponse;
};
const DashboardJobMatches = ({ isLoading, jobMatches, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [layout, setLayout] = useState<'grid' | 'list'>('list');

  const windowWidth = useWindowWidth();
  const onMobile = windowWidth !== undefined && windowWidth < 768;
  if (onMobile && layout !== 'grid') setLayout('grid');
  else if (!onMobile && layout !== 'list') setLayout('list');

  const toggle = () => setInfoModalOpen((prev) => !prev);

  if (isLoading) return <Loading />;

  return (
    <section className="mysynergie-dashboard-jobsuggestions mb-5">
      <JobmatchInfoModal dictionary={dictionary} toggle={toggle} isOpen={infoModalOpen} />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0 d-block d-md-none">{capitalizeFirstLetter(formatMessage({ id: 'mysynergie_jobmatches' }))}</h2>
        <h2 className="mb-0 d-none d-md-block">{capitalizeFirstLetter(formatMessage({ id: 'mysynergie_your_suggestions' }))}</h2>
        <Button className="button-mysynergie-secondary d-flex align-items-center p-2" onClick={toggle}>
          <MdOutlineInfo />
          <span className="d-none d-md-inline ms-2">{capitalizeFirstLetter(formatMessage({ id: 'info' }))}</span>
        </Button>
      </div>
      {jobMatches?.matches.length === 0 && <JobmatchNoResults dictionary={dictionary} onMobile={onMobile} className="bg-light" />}
      {jobMatches?.matches.length > 0 && (
        <>
          <ListGroup>
            {jobMatches.matches.map((match, index) => (
              <JobTeaser
                dictionary={dictionary}
                key={`match-${index}-${match.id}`}
                job={match.job}
                layout={layout}
                titleTag="h5"
              />
            ))}
          </ListGroup>
          <div className="d-flex align-items-center justify-content-end">
            <Link
              href={`/${locale}/my-synergie/jobmatches`}
              className="button button-outline-primary d-flex align-items-center py-2 px-4"
            >
              {capitalizeFirstLetter(formatMessage({ id: 'mysynergie_jobmatches_view_all' }))}
              <MdOutlineChevronRight size={16} className="ms-1" />
            </Link>
          </div>
        </>
      )}
    </section>
  );
};

export default DashboardJobMatches;
